var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "review-card-meta",
      class: _setup.isMobile ? "d-flex flex-column" : "review-card-meta--aside",
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-center",
          class: { "justify-space-between": _setup.isMobile },
        },
        [
          _c("div", [
            _c("meta", {
              attrs: { itemprop: "itemReviewed", content: _setup.itemReviewed },
            }),
            _vm._v(" "),
            _c(
              "div",
              _vm._b(
                {
                  staticClass:
                    "review-card-meta__author text-subtitle-1 primary--text",
                  class: { "mb-1": !_setup.isMobile },
                  attrs: { itemprop: "author" },
                },
                "div",
                _setup.authorAttrs,
                false
              ),
              [
                _setup.author.patientProfileId
                  ? _c(
                      "div",
                      {
                        staticClass: "review-card-meta__author-link",
                        attrs: {
                          "data-qa": "patient_profile__node_author_link",
                          "data-patient-data": _setup.patientData,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _setup.onAuthorClick.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.author.label) +
                            "\n        "
                        ),
                      ]
                    )
                  : [
                      _vm._v(
                        "\n          " +
                          _vm._s(_setup.author.label) +
                          "\n        "
                      ),
                    ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _setup.isMobile ? _c(_setup.ReviewCardLogo) : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _setup.participationLabel
        ? _c(
            "div",
            {
              staticClass: "text-body-2 text-secondary--text",
              class: { "mb-1": !_setup.isMobile },
            },
            [_vm._v("\n    " + _vm._s(_setup.participationLabel) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-body-2 text-secondary--text",
          class: { "mb-5": !_setup.isMobile },
          attrs: { itemprop: "datePublished", content: _setup.isoDate },
        },
        [_vm._v("\n    " + _vm._s(_setup.publishedDate) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: { "mt-3": _setup.isMobile } },
        [_c(_setup.ReviewCardTooltips, { attrs: { rate: _vm.rate } })],
        1
      ),
      _vm._v(" "),
      _setup.avgRate != null
        ? _c(
            "div",
            {
              attrs: {
                itemprop: "reviewRating",
                itemscope: "",
                itemtype: "https://schema.org/Rating",
              },
            },
            [
              _c("meta", {
                attrs: { itemprop: "ratingValue", content: _setup.ratingValue },
              }),
              _vm._v(" "),
              _c("meta", { attrs: { itemprop: "worstRating", content: "0" } }),
              _vm._v(" "),
              _c("meta", { attrs: { itemprop: "bestRating", content: "100" } }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }